import React from "react";
import Image from "../assets/History.png";
import Logo from "../assets/Logo.png";

const History = () => {
  return (
    <>
    <div
      id="history"
      className="bg-[#FAEBCC] w-full h-full flex lg:flex-row flex-col justify-center	 md:pb-20 pb-80 items-center pt-28	"
    >
      <div className="px-10 pt-10 text-center ">
        <img className="h-80 w-[600px]" src={Image} alt=""></img>
        <img className="h-10 pt-4" src={Logo} alt=""></img>
        <h1 className="text-left">12 +YEARS IN MARKETING</h1>
      </div>
      <div className="  mt-14 flex flex-col ">
        <h1 className="text-red-400 flex justify-center items-center ">
          [Our History]
        </h1>
        <div className="flex flex-col gap-16 mt-20 justify-center items-center ">
          <div className="flex-col flex justify-center items-center  ">
            <h1 className="text-red-800 text-5xl font-bold">219+</h1>
            <p className="md:w-90 w-40 mt-2  flex-col flex justify-center items-center  ">
              Unique strategies developed using AI
            </p>
          </div>
          <div className=" flex-col flex justify-center items-center  ">
            <h1 className="text-red-800 text-5xl font-bold">10+</h1>
            <p className="md:w-90 mt-2 flex-col flex justify-center items-center  ">Employees</p>
          </div>
        </div>
      </div>
      <div className="h-80  flex flex-col ">
        <div className="md:w-[600px] p-6 flex  flex-col justify-center items-center ">
          <p className="md:text-left text-center">
            <span className="font-bold"> Welcome to Krisoft! </span>Founded in
            2012, Krisoft is a product of driven minds to shape the world in a
            way like never before. We started this journey with a simple yet
            dynamic mission: to make businesses thrive in the digital age. With
            a passionate team, we worked hard enough to grow into a full-service
            digital marketing agency, trusted by prominent brands.
          </p>
          <p className="md:text-left text-center mt-6">
            In the early days, brands focused on mastering basic advertising. As
            the digital world evolved, so did we. We expanded our expertise to
            branding, marketing, UI/UX designs, web development and whatnot.
          </p>
          <p className="md:text-left text-center mt-6">
            Today, we stand as a leading digital marketing agency driven by the
            same passion to achieve milestones daily.
          </p>
        </div>
        <div className="flex md:flex-row flex-col gap-10  mt-5 justify-center items-center mr-10 ">
          <div className="flex flex-col">
            <h1 className="text-red-800 text-5xl font-bold">100+</h1>
            <p className="">Project Delivery</p>
          </div>
          <div className="flex-col flex justify-center items-center  ">
            <h1 className="text-red-800 text-5xl font-bold">12+</h1>
            <p className="">Years Experience</p>
          </div>
        </div>
      </div>
    </div>

    </>
  );
};

export default History;
